import { required, validateError } from "../../../utils/validate";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { createLoading } from "../../../utils/loading";
import { conditionFormChecker, initUseForm, putField } from "../../../utils/form";
import { useForm as createUseForm } from "@ant-design-vue/use";
import { createFieldSelect } from "../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../i18n";
import lodash from "lodash";
import { callSearchSurvey } from "./survey-answer.section";
import { modalStyleForm } from "../../../utils/constant";
import { addModal } from "../../../app.logic";

export const { isLoading, setIsLoading } = createLoading();

export const CreateResponseSurveyForm = defineAsyncComponent(() => import("./CreateResponseSurveyForm"));

export const openModalForm = ({ props, onOk, bind }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okButtonProps: { disabled: false },
                title: i18n.global.t("views.surveyAnswer.modal.title"),
                width: "750px",
                onOk: () => {
                    refs.form.callOnClickModalOk().then(record => {
                        onOk?.(record);
                        options.bind.onCancel();
                    });
                }
            },
            bind
        ),
        render: () => (
            <CreateResponseSurveyForm
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
            ></CreateResponseSurveyForm>
        )
    });
    return options;
};

export const createForm = () => {
    return {
        refSurvey: null,
    };
};

export const createRules = () => {
    return {
        refSurvey: [required],
    };
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then(page => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSurvey`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 6 }, wrapperCol: { xs: 24, md: 18 } }),
                label: () => i18n.global.t("model.surveyAnswer.refOrigin"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSurvey,
                            "onUpdate:value": value => {
                                model.refSurvey = value
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callSearchSurvey({ searchQuery }),
                            optLabel: "title"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            })
        ]
    })
}